<template>
  <div class=" font-inter">
    <main class="w-full">
      <LockInModeComponent />
    </main>
  </div>
</template>
  
  <script>
  import LockInModeComponent from '@/components/lock-in-mode/LockInModeComponent.vue';

  export default {
    name: 'LockInModeView',
    components: {
        LockInModeComponent,
    },
    mounted() {
      window.scrollTo(0, 0);
      this.checkForSuccessMessage();
    },
    methods: {
      checkForSuccessMessage() {
        if (this.$route.query.success === 'true' && this.$route.query.message) {
          this.$emit('show-success', this.$route.query.message);
          
          // Clean up the URL parameters
          this.$router.replace({ 
            path: this.$route.path, 
            query: {} 
          });
        }
      }
    }
  }
  </script>
  
  <style scoped>
  </style>
  